export default {"src":"/_next/static/media/laboratory-free-pik-plants.c260325f.svg","height":213,"width":140,"blurWidth":0,"blurHeight":0};